export enum LoginTrackingPoint {
  PageView = 'PageView',
  LoginButtonClick = 'LoginButtonClick',
  ForgotButtonClick = 'ForgotButtonClick',
  HelpButtonClick = 'HelpButtonClick',
  LoginSuccessAction = 'LoginSuccessAction',
  LoginFailAction = 'LoginFailAction',
  BackButtonClick = 'BackButtonClick',
  SignupButtonClick = 'SignupButtonClick',
  LoginFailedToastAction = 'LoginFailedToastAction',
  LoginWithSMSButtonClick = 'LoginWithSMSButtonClick',
  LoginWithSMSNextButtonClick = 'LoginWithSMSNextButtonClick',
  LoginWithSMSLoginWithPasswordButtonClick = 'LoginWithSMSLoginWithPasswordButtonClick',
  LoginWithSMSCaptchaPopupImpression = 'LoginWithSMSCaptchaPopupImpression',
  LoginWithSMSCaptchaPopupOkButtonClick = 'LoginWithSMSCaptchaPopupOkButtonClick',
  LoginWithSMSCaptchaPopupRefreshButtonClick = 'LoginWithSMSCaptchaPopupRefreshButtonClick',
  LoginWithSMSCaptchaPopupCancelButtonClick = 'LoginWithSMSCaptchaPopupCancelButtonClick',
  LoginWithPasswordAddPhoneEmailPopupView = 'LoginWithPasswordAddPhoneEmailPopupView',
  LoginWithPasswordAddPhoneEmailPopupOkClick = 'LoginWithPasswordAddPhoneEmailPopupOkClick',
  LoginWithThirdPartyGoogle = 'LoginWithThirdPartyGoogle',
  LoginWithThirdPartyFacebook = 'LoginWithThirdPartyFacebook',
  LoginWithThirdPartyApple = 'LoginWithThirdPartyApple',
  LoginWithThirdPartyShopee = 'LoginWithThirdPartyShopee',
  LoginByTokenSuccessAction = 'LoginByTokenSuccessAction',
  QuickLoginToggleImpression = 'QuickLoginToggleImpression',
  QuickLoginToggleClick = 'QuickLoginToggleClick',
  QuickLoginTooltipImpression = 'QuickLoginTooltipImpression',
  QuickLoginActionSuccess = 'QuickLoginActionSuccess',
  LoginWithBusinessGoogleButtonClick = 'LoginWithBusinessGoogleButtonClick',
}

export enum OTPDialogTrackingPoint {
  OTPDialogPopupImpression = 'OTPDialogPopupImpression',
  OTPDialogPopupConfirmButtonClick = 'OTPDialogPopupConfirmButtonClick',
}

export enum OTPEnterVerificationTrackingPoint {
  PageView = 'PageView',
  NextButtonClick = 'NextButtonClick',
  BackButtonClick = 'BackButtonClick',
  HelpButtonClick = 'HelpButtonClick',
  ResendButtonClick = 'ResendButtonClick',
  DifferentMethodButtonClick = 'DifferentMethodButtonClick',
  VerificationResult = 'VerificationResult',
  PhoneAlreadyUsedView = 'PhoneAlreadyUsedView',
  PhoneAlreadyUsedOkButtonClick = 'PhoneAlreadyUsedOkButtonClick',
  PhoneAlreadyUsedContactUsButtonClick = 'PhoneAlreadyUsedContactUsButtonClick',
  EmailAlreadyUsedView = 'EmailAlreadyUsedView',
  EmailAlreadyUsedOkButtonClick = 'EmailAlreadyUsedOkButtonClick',
  EmailAlreadyUsedContactUsButtonClick = 'EmailAlreadyUsedContactUsButtonClick',
  AccountBannedPopupView = 'AccountBannedPopupView',
  AccountBannedPopupOkButtonClick = 'AccountBannedPopupOkButtonClick',
  AccountBannedPopupContactUsButtonClick = 'AccountBannedPopupContactUsButtonClick',
}

export enum OTPSelectVerificationTrackingPoint {
  PageView = 'PageView',
  CallButtonClick = 'CallButtonClick',
  SmsButtonClick = 'SmsButtonClick',
  WhatsAppButtonClick = 'WhatsAppButtonClick',
  ViberButtonClick = 'ViberButtonClick',
  BackButtonClick = 'BackButtonClick',
  HelpButtonClick = 'HelpButtonClick',
  ZaloButtonClick = 'ZaloButtonClick',
}

export enum ResetPasswordTrackingPoint {
  PageView = 'PageView',
  NextButtonClick = 'NextButtonClick',
  HelpButtonClick = 'HelpButtonClick',
  BackButtonClick = 'BackButtonClick',
  ContactUsButtonClick = 'ContactUsButtonClick',
  CaptchaPopupImpression = 'CaptchaPopupImpression',
  CaptchaPopupOkButtonClick = 'CaptchaPopupOkButtonClick',
  CaptchaPopupCancelButtonClick = 'CaptchaPopupCancelButtonClick',
  CaptchaPopupRefreshButtonClick = 'CaptchaPopupRefreshButtonClick',
  ResetPasswordOnShopeeView = 'ResetPasswordOnShopeeView',
  ResetPasswordOnShopeeOkClick = 'ResetPasswordOnShopeeOkClick',
  ResetPasswordOnShopeeContactUsClick = 'ResetPasswordOnShopeeContactUsClick',
  ResetPasswordOnShopeeCancelClick = 'ResetPasswordOnShopeeCancelClick',
  ResetPasswordSuccessAction = 'ResetPasswordSuccessAction',
}

export enum SetNewPasswordTrackingPoint {
  PageView = 'PageView',
  OkButtonClick = 'OkButtonClick',
  BackButtonClick = 'BackButtonClick',
  HelpButtonClick = 'HelpButtonClick',
  SetPasswordSuccessAction = 'SetPasswordSuccessAction',
}

export enum VerifyCurrentPasswordTrackingPoint {
  PageView = 'PageView',
  NextButtonClick = 'NextButtonClick',
  BackButtonClick = 'BackButtonClick',
}

export enum MyAccountTrackingPoint {
  PageView = 'PageView',
  ChangePasswordButtonClick = 'ChangePasswordButtonClick',
  BackButtonClick = 'BackButtonClick',
  PhoneInfoButtonClick = 'PhoneInfoButtonClick',
  EmailInfoButtonClick = 'EmailInfoButtonClick',
  LogoutButtonClick = 'LogoutButtonClick',
  LogoutPopupImpression = 'LogoutPopupImpression',
  LogoutPopupConfirmButton = 'LogoutPopupConfirmButton',
  LogoutPopupCancelButton = 'LogoutPopupCancelButton',
  LinkWithShopeeAccountClick = 'LinkWithShopeeAccountClick',
  LinkToADifferentShopeeAccountClick = 'LinkToADifferentShopeeAccountClick',
  LoginWithPasscodeButtonClick = 'LoginWithPasscodeButtonClick',
  ReturnToPartnerAccountButtonClick = 'ReturnToPartnerAccountButtonClick',
  DeleteAccountButtonClick = 'DeleteAccountButtonClick',
  QuickLoginToggleClick = 'QuickLoginToggleClick',
  QuickLoginLogoutPopupImpression = 'QuickLoginLogoutPopupImpression',
  QuickLoginLogoutConfirmButton = 'QuickLoginLogoutConfirmButton',
  QuickLoginLogoutBackButton = 'QuickLoginLogoutBackButton',
}

export enum MyStaffAccountListTrackingPoint {
  PageView = 'PageView',
  BackButtonClick = 'BackButtonClick',
  StaffAccountButtonClick = 'StaffAccountButtonClick',
}

export enum MerchantAccountSettingTrackingPoint {
  PageView = 'PageView',
  BackButtonClick = 'BackButtonClick',
  MyAccountButtonClick = 'MyAccountButtonClick',
  MyStaffAccountButtonClick = 'MyStaffAccountButtonClick',
  LogoutPopupImpression = 'LogoutPopupImpression',
  LogoutButtonClick = 'LogoutButtonClick',
  LogoutPopupConfirmButtonClick = 'LogoutPopupConfirmButtonClick',
  LogoutPopupCancelButtonClick = 'LogoutPopupCancelButtonClick',
}

export enum StaffAccountDetailsTrackingPoint {
  PageView = 'PageView',
  ChangeStaffPassword = 'ChangeStaffPassword',
}

export enum EnterNewPhoneTrackingPoint {
  PageView = 'PageView',
  NextButtonClick = 'NextButtonClick',
  BackButtonClick = 'BackButtonClick',
  HelpButtonClick = 'HelpButtonClick',
}

export enum EnterNewEmailTrackingPoint {
  PageView = 'PageView',
  NextButtonClick = 'NextButtonClick',
  BackButtonClick = 'BackButtonClick',
  HelpButtonClick = 'HelpButtonClick',
}

export enum ChangePhoneTrackingPoint {
  ChangePhoneSuccessAction = 'ChangePhoneSuccessAction',
  ChangePhoneFailAction = 'ChangePhoneFailAction',
  ChangePhoneRateLimitPopupImpression = 'ChangePhoneRateLimitPopupImpression',
}

export enum ChangeEmailTrackingPoint {
  ChangeEmailSuccessAction = 'ChangeEmailSuccessAction',
  ChangeEmailFailAction = 'ChangeEmailFailAction',
  ChangeEmailRateLimitPopupImpression = 'ChangeEmailRateLimitPopupImpression',
}

export enum AccountUpdateTrackingPoint {
  MethodSelectionPageView = 'MethodSelectionPageView',
  MethodSelectionLinkEmailButtonClick = 'MethodSelectionLinkEmailButtonClick',
  MethodSelectionLinkPhoneButtonClick = 'MethodSelectionLinkPhoneButtonClick',
  MethodSelectionSetUpLaterClick = 'MethodSelectionSetUpLaterClick',
  SkipAccountUpdateClick = 'SkipAccountUpdateClick',
  LinkAccountPageView = 'LinkAccountPageView',
  LinkAccountBackButtonClick = 'LinkAccountBackButtonClick',
  LinkAccountRequestSentPopupView = 'LinkAccountRequestSentPopupView',
  LinkAccountRequestSentPopupOkButtonClick = 'LinkAccountRequestSentPopupOkButtonClick',
  VerifyPhoneEmailButtonClick = 'VerifyPhoneEmailButtonClick',
  VerifyPhoneEmailButtonImpression = 'VerifyPhoneEmailButtonImpression',
  ChangePhoneEmailButtonClick = 'ChangePhoneEmailButtonClick',
  ChangePhoneEmailButtonImpression = 'ChangePhoneEmailButtonImpression',
  AddPhoneEmailButtonClick = 'AddPhoneEmailButtonClick',
  AddPhoneEmailButtonImpression = 'AddPhoneEmailButtonImpression',
  SetupLaterClick = 'SetupLaterClick',
  AccountLinkedSuccessPageView = 'AccountLinkedSuccessPageView',
  AccountLinkedSuccessAction = 'AccountLinkedSuccessAction',
  AccountLinkedTryNowButtonClick = 'AccountLinkedTryNowButtonClick',
}

export enum AccountBindTrackingPoint {
  AccountBindingPageView = 'AccountBindingPageView',
  AccountBindingContinueButtonClick = 'AccountBindingContinueButtonClick',
  AccountBindingLinkingFailedView = 'AccountBindingLinkingFailedView',
  AccountBindingLinkingFailedContactUsClick = 'AccountBindingLinkingFailedContactUsClick',
  AccountBindingLinkingFailedOkButtonClick = 'AccountBindingLinkingFailedOkButtonClick',
  ReclaimPhoneClick = 'ReclaimPhoneClick',
  ReclaimPhoneSuccessAction = 'ReclaimPhoneSuccessAction',
  ReclaimPhoneFailedPageView = 'ReclaimPhoneFailedPageView',
  ReclaimPhoneFailedHelpButtonClick = 'ReclaimPhoneFailedHelpButtonClick',
  ReclaimPhoneFailedContactCustomerServiceClick = 'ReclaimPhoneFailedContactCustomerServiceClick',
  ReclaimPhoneFailedGoHelpCenterClick = 'ReclaimPhoneFailedGoHelpCenterClick',
  CreateAccountPageView = 'CreateAccountPageView',
  CreateAccountContinueButtonClick = 'CreateAccountContinueButtonClick',
  SetPasswordPageView = 'SetPasswordPageView',
  SetPasswordConfirmButtonClick = 'SetPasswordConfirmButtonClick',
  SetPasswordHelpButtonClick = 'SetPasswordHelpButtonClick',
  SetPasswordSuccessAction = 'SetPasswordSuccessAction',
}

export enum ThirdPartyAccountLinkageTrackingPoint {
  PageView = 'ThirdPartyAccountLinkagePageView',
  LinkWithThirdPartyGoogle = 'LinkWithThirdPartyGoogle',
  LinkWithThirdPartyFacebook = 'LinkWithThirdPartyFacebook',
  LinkWithThirdPartyApple = 'LinkWithThirdPartyApple',
  LinkWithThirdPartyShopee = 'LinkWithThirdPartyShopee',
  LinkWithThirdPartySuccessAction = 'LinkWithThirdPartySuccessAction',
  LinkWithThirdPartyFailAction = 'LinkWithThirdPartyFailAction',
  UnlinkWithThirdPartyPopupView = 'UnlinkWithThirdPartyPopupView',
  UnlinkWithThirdPartyConfirmClick = 'UnlinkWithThirdPartyConfirmClick',
  UnlinkWithThirdPartyCancelClick = 'UnlinkWithThirdPartyCancelClick',
}

export enum SignupTrackingPoint {
  SignupPageView = 'SignupPageView',
  SignupHelpButtonClick = 'SignupHelpButtonClick',
  SignupNextButtonClick = 'SignupNextButtonClick',
  EnterpriseAccountSubmitFormButtonClick = 'EnterpriseAccountSubmitFormButtonClick',
  PhoneAlreadyRegisteredPageView = 'PhoneAlreadyRegisteredPageView',
  PhoneAlreadyRegisteredLoginButtonClick = 'PhoneAlreadyRegisteredLoginButtonClick',
  PhoneAlreadyRegisteredContactUsButtonClick = 'PhoneAlreadyRegisteredContactUsButtonClick',
  PhoneAlreadyRegisteredHelpButtonClick = 'PhoneAlreadyRegisteredHelpButtonClick',
  EmailAlreadyRegisteredPageView = 'EmailAlreadyRegisteredPageView',
  EmailAlreadyRegisteredLoginButtonClick = 'EmailAlreadyRegisteredLoginButtonClick',
  EmailAlreadyRegisteredContactUsButtonClick = 'EmailAlreadyRegisteredContactUsButtonClick',
  EmailAlreadyRegisteredHelpButtonClick = 'EmailAlreadyRegisteredHelpButtonClick',
  SignupSetPasswordPageView = 'SignupSetPasswordPageView',
  SignupSetPasswordSignupButtonClick = 'SignupSetPasswordSignupButtonClick',
  SignupSetPasswordBackButtonClick = 'SignupSetPasswordBackButtonClick',
  SignupSuccessPageView = 'SignupSuccessPageView',
  SignupSuccessPageNextButtonClick = 'SignupSuccessPageNextButtonClick',
  SignupSuccessPageBackButtonClick = 'SignupSuccessPageBackButtonClick',
  SignupSuccessAction = 'SignupSuccessAction',
  QuickLoginToggleImpression = 'QuickLoginToggleImpression',
  QuickLoginToggleClick = 'QuickLoginToggleClick',
  QuickLoginTooltipImpression = 'QuickLoginTooltipImpression',
  QuickLoginActionSuccess = 'QuickLoginActionSuccess',
  LoginSuccessAction = 'LoginSuccessAction',
}

export enum BiometricPromptTrackingPoint {
  PageView = 'BiometricPromptPageView',
  EnableBiometricClick = 'BiometricPromptEnableBiometricClick',
  SetupLaterClick = 'BiometricPromptSetupLaterClick',
  BackClick = 'BiometricPromptBackClick',
  EnableSuccessImpression = 'BiometricPromptImpression',
  EnableSuccessOkClick = 'BiometricPromptEnableSuccessOkClick',
  EnableFailTooManyTimesOkClick = 'BiometricPromptEnableFailTooManyTimesOkClick',
  EnableFailTooManyTimesImpression = 'BiometricPromptEnableFailTooManyTimesImpression',
}

export enum ReloginBiometricsTrackingPoint {
  PageView = 'ReloginBiometricsPageView',
  ReloginBiometricLoginClick = 'ReloginBiometricsReloginBiometricLoginClick',
  ReloginWithOtherMethodsClick = 'ReloginBiometricsReloginWithOtherMethodsClick',
  ReloginWithAnotherAccountClick = 'ReloginBiometricsReloginWithAnotherAccountClick',
  ReloginSignupClick = 'ReloginBiometricsReloginSignupClick',
  LoginWithOtherMethodsSelectionImpression = 'ReloginBiometricsLoginWithOtherMethodsSelectionImpression',
  LoginWithOtherMethodsLoginWithPhoneClick = 'ReloginBiometricsLoginWithOtherMethodsLoginWithPhoneClick',
  LoginWithOtherMethodsLoginWithPasswordClick = 'ReloginBiometricsLoginWithOtherMethodsLoginWithPasswordClick',
  LoginWithOtherMethodsLoginWithQuickLoginClick = 'ReloginBiometricsLoginWithOtherMethodsLoginWithQuickLoginClick',
  QuickLoginToggleImpression = 'ReloginBiometricsQuickLoginToggleImpression',
  QuickLoginToggleClick = 'ReloginBiometricsQuickLoginToggleClick',
  QuickLoginTooltipImpression = 'ReloginBiometricsQuickLoginTooltipImpression',
  QuickLoginActionSuccess = 'ReloginBiometricsQuickLoginActionSuccess',
}

export enum ReloginQuickLoginTrackingPoint {
  PageView = 'ReloginQuickLoginPageView',
  ReloginWithOtherMethodsClick = 'ReloginQuickLoginReloginWithOtherMethodsClick',
  LoginWithOtherMethodsSelectionImpression = 'ReloginQuickLoginLoginWithOtherMethodsSelectionImpression',
  LoginWithOtherMethodsSelectionClick = 'ReloginQuickLoginLoginWithOtherMethodsSelectionClick',
  ReloginWithAnotherAccountClick = 'ReloginQuickLoginReloginWithAnotherAccountClick',
  ReloginSignupClick = 'ReloginQuickLoginReloginSignupClick',
}

export enum QuickLoginPromptTrackingPoint {
  QuickLoginPromptPageView = 'QuickLoginPromptPageView',
  QuickLoginPromptEnableQuickLoginClick = 'QuickLoginPromptEnableQuickLoginClick',
  QuickLoginPromptBackClick = 'QuickLoginPromptBackClick',
}

export enum ReloginPasswordTrackingPoint {
  PageView = 'ReloginPasswordPageView',
  ReloginSignupClick = 'ReloginPasswordReloginSignupClick',
  ReloginWithAnotherAccountClick = 'ReloginPasswordReloginWithAnotherAccountClick',
  ReloginWithOtherMethodsClick = 'ReloginPasswordReloginWithOtherMethodsClick',
  ReloginWithPasswordLoginClick = 'ReloginPasswordReloginWithPasswordLoginClick',
  ReloginHelpClick = 'ReloginPasswordReloginHelpClick',
  ForgotPasswordClick = 'ReloginPasswordForgotPasswordClick',
  LoginWithOtherMethodsSelectionImpression = 'ReloginPasswordLoginWithOtherMethodsSelectionImpression',
  LoginWithOtherMethodsLoginWithPhoneClick = 'ReloginPasswordLoginWithOtherMethodsLoginWithPhoneClick',
  LoginWithOtherMethodsLoginWithBiometricsClick = 'ReloginPasswordLoginWithOtherMethodsLoginWithBiometricsClick',
  LoginWithOtherMethodsLoginWithQuickLoginClick = 'LoginWithOtherMethodsLoginWithQuickLoginClick',
  QuickLoginToggleImpression = 'ReloginPasswordQuickLoginToggleImpression',
  QuickLoginToggleClick = 'ReloginPasswordQuickLoginToggleClick',
  QuickLoginTooltipImpression = 'ReloginPasswordQuickLoginTooltipImpression',
  QuickLoginActionSuccess = 'ReloginPasswordQuickLoginActionSuccess',
}

export enum WhatsappAuthLinkTrackingPoint {
  PageView = 'VerifyWhatsappAuthLinkPageView',
  WhatsappAuthLinkOpenWhatsappClick = 'WhatsappAuthLinkOpenWhatsappClick',
  WhatsappAuthLinkHelpClick = 'WhatsappAuthLinkHelpClick',
  WhatsappAuthLinkBackButton = 'WhatsappAuthLinkBackButton',
  ResendWhatsappAuthLinkImpression = 'ResendWhatsappAuthLinkImpression',
  ResendWhatsappAuthLinkClick = 'ResendWhatsappAuthLinkClick',
  WhatsappAuthLinkTryAnotherMethodClick = 'WhatsappAuthLinkTryAnotherMethodClick',
  WhatsappAuthLinkTryAnotherMethodImpression = 'WhatsappAuthLinkTryAnotherMethodImpression',
  WhatsappAuthLinkLoginWithOtherMethodImpression = 'WhatsappAuthLinkLoginWithOtherMethodImpression',
  WhatsappAuthLinkLoginWithOtherMethodsClick = 'WhatsappAuthLinkLoginWithOtherMethodsClick',
  WhatsappAuthLinkLoginWithPhoneImpression = 'WhatsappAuthLinkLoginWithPhoneImpression',
  WhatsappAuthLinkLoginWithPhoneClick = 'WhatsappAuthLinkLoginWithPhoneClick',
  WhatsappAuthLinkLoginWithBiometricsImpression = 'WhatsappAuthLinkLoginWithPhoneBiometricsImpression',
  WhatsappAuthLinkLoginWithBiometricsClick = 'WhatsappAuthLinkLoginWithPhoneBiometricsClick',
  WhatsappAuthLinkLoginWithPasswordImpression = 'WhatsappAuthLinkLoginWithPasswordImpression',
  WhatsappAuthLinkLoginWithPasswordClick = 'WhatsappAuthLinkLoginWithPasswordClick',
  WhatsappAuthLinkLoginWithQuickLoginClick = 'WhatsappAuthLinkLoginWithQuickLoginClick',
}

export enum OneCredentialDelinkTrackingPoint {
  DelinkInitPageView = 'DelinkInitPageView',
  DelinkInitPageContinueClick = 'DelinkInitPageContinueClick',
  DelinkInitPageCancelClick = 'DelinkInitPageCancelClick',
  DelinkInitPageBackClick = 'DelinkInitPageBackClick',
  DelinkSetupTobAccountPageView = 'DelinkSetupTobAccountPageView',
  DelinkSetupTobAccountPageNextClick = 'DelinkSetupTobAccountPageNextClick',
  DelinkSetupTobAccountPageBackClick = 'DelinkSetupTobAccountPageBackClick',
  DelinkSetupPasswordPageView = 'DelinkSetupPasswordPageView',
  DelinkSetupPasswordPageConfirmClick = 'DelinkSetupPasswordPageConfirmClick',
  DelinkSetupPasswordPageBackClick = 'DelinkSetupPasswordPageBackClick',
  DelinkSuccessPageView = 'DelinkSuccessPageView',
  DelinkSuccessPageContinueClick = 'DelinkSuccessPageContinueClick',
  DelinkSuccessPageBackClick = 'DelinkSuccessPageBackClick',
  DelinkSuccessAction = 'DelinkSuccessAction',
  DelinkErrorPageView = 'DelinkErrorPageView',
}
